/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
  uid         : 0,          // From Auth
  displayName : "Will Smith", // From Auth
  about       : "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
  photoURL    : require("@/assets/images/portrait/small/avatar-s-11.jpg"), // From Auth
  status      : "online",
  userRole    : "admin",
  is_client   : "y",
  rolePermission : [
    {"resourceName" : "Roles","read":false,"write":false,"update":false,"delete":false,"name":"roles"},
    {"resourceName" : "User Types","read":false,"write":false,"update":false,"delete":false,"name":"user_types"},
    {"resourceName" : "Clients","read":false,"write":false,"update":false,"delete":false,"name":"clients"},
    {"resourceName" : "Elomark Users","read":false,"write":false,"update":false,"delete":false,"name":"elomark_users"},
    {"resourceName" : "Client Users","read":false,"write":false,"update":false,"delete":false,"name":"client_users"},
    {"resourceName" : "Campaigns","read":false,"write":false,"update":false,"delete":false,"name":"campaigns"},
    {"resourceName" : "Accounts","read":false,"write":false,"update":false,"delete":false,"name":"accounts"},
    {"resourceName" : "Contacts","read":false,"write":false,"update":false,"delete":false,"name":"contacts"},
    {"resourceName" : "Import Contacts","read":false,"name":"import_contacts"},
    {"resourceName" : "Match Accounts","read":false,"name":"match_accounts"},
    {"resourceName" : "Import accounts with company registration number","read":false,"name":"import_accounts_with_company_registration_number"},
    {"resourceName" : "Import accounts using machine learning","read":false,"name":"import_accounts_using_machine_learning"},
    {"resourceName" : "Resume Imported accounts","read":false,"name":"resume_imported_accounts"},
    {"resourceName" : "Unmatched Accounts","read":false,"name":"unmatched_accounts"},
    ],
    roleId:0
}

const userInfoLocalStorage = JSON.parse(localStorage.getItem("userInfo")) || {}

// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
const getUserInfo = () => {
  let userInfo = {}

  // Update property in user
  Object.keys(userDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    userInfo[key] = userInfoLocalStorage[key] ?  userInfoLocalStorage[key] : userDefaults[key]
  })

  // Include properties from localStorage
  Object.keys(userInfoLocalStorage).forEach((key) => {
    if(userInfo[key] == undefined && userInfoLocalStorage[key] != null) userInfo[key] = userInfoLocalStorage[key]
  })

  return userInfo
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
    AppActiveUser           : getUserInfo(),
    bodyOverlay             : false,
    isVerticalNavMenuActive : true,
    mainLayoutType          : themeConfig.mainLayoutType || "vertical",
    navbarSearchAndPinList  : navbarSearchAndPinList,
    reduceButton            : themeConfig.sidebarCollapsed,
    verticalNavMenuWidth    : "default",
    verticalNavMenuItemsMin : false,
    scrollY                 : 0,
    starredPages            : navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
    theme                   : themeConfig.theme || "light",
    themePrimaryColor       : colors.primary,

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,
}

export default state
